export const magdalenaSmorowska = {
    'mydrId': 'magdalenasmorowska',
    'firstName': 'Magdalena',
    'lastName': 'Smorowska',
    'profession': 'Psycholog, psychoterapeuta, psychoonkolog, terapeuta uzależnień',
    'avatar': 'magdalena-smorowska.webp',
    'slug': 'psychoterapeuta-magdalena-smorowska',
    'locations': ['torun'],
    'services': []
}